import { ctaDestinationForPath } from '../../../common/ctaTelemetry';

const PLACEMENT_BY_DESTINATION = {
  pricing: 'topnav_pricing',
  checkout: 'topnav_join',
  sign_up: 'topnav_join',
  log_in: 'topnav_login',
} as const;

export function topNavActionPlacement(href: string): string | undefined {
  const destination = ctaDestinationForPath(href.split(/[?#]/)[0]);
  return destination === undefined
    ? undefined
    : PLACEMENT_BY_DESTINATION[destination];
}
